import React from "react";
import "./App.css";
import Checkboxes from "./components/Checkboxes.js";

function App() {
  return (
    <div className="App">
      <Checkboxes />
    </div>
  );
}

export default App;
